(function ($) {

	var $lists = $('.component.list');
	var debouncedResize = window._debounce(adjustListItemHeights, 100);
	var rowCount = 0;

	$(window)
		.on('load resize', adjustListItemHeights)
		.resize(debouncedResize);

	$(adjustListItemHeights);

	function adjustListItemHeights() {
        setTimeout(function() {
            $lists.each(function () {
			if ($(this).find('.component.s01-surfaced-item').length || $(this).find(".s03-surfaced-item").length) {
				var surfaceItemCount = ($(this).find('.component.s01-surfaced-item').length);
				var s03ItemCount = $(this).find(".s03-surfaced-item").length;
				var columnCount = getColumnCount($(this));
				if (isFinite(columnCount)) {
					if (surfaceItemCount > 0) {
						var rowCounts01 = Math.round(surfaceItemCount / columnCount);
						if (rowCounts01 > 1) {
							$('.component.list .component.s01-surfaced-item').each(function (i, ele) {
								$(this).css('margin-bottom', '2rem');
							});
						}

					}
					if (s03ItemCount > 0) {
						var rowCounts03 = Math.round(s03ItemCount / columnCount);
						if (rowCounts03 > 1) {
							$('.component.list .s03-surfaced-item').each(function (i, ele) {
								$(this).css('margin-bottom', '2rem');
							});
						}

					}
				}

				return;

			}
			var list = $(this);
			var columns = getColumnCount(list);
				if (isFinite(columns)) {
					setItemHeights(list, columns);
				}
		});
        },2000);
		
	}

	function getColumnCount(list) {
		return Math.round(1 / (list.children('li:first').outerWidth() / list.outerWidth()), 0);
	}

	function setItemHeights(list, columns) {
		var items = list.children('li');
		clearHeight(items);
		if (columns === 1) return;
		var heights = getRowHeight(items, columns);
		rowCount = heights.length;
		setRowHeight(items, columns, heights);
	}

	function clearHeight(items) {
		items.css('height', 'auto');
	}

	function getRowHeight(items, columns) {
		var heights = [];
		items.each(function (i) {
			if (i % columns === 0) heights.push(0);
			heights[heights.length - 1] = Math.max(heights[heights.length - 1], getItemHeight($(this)));
		});
		return heights;
	}

	function setRowHeight(items, columns, heights) {
		for (var h = 0; h < heights.length; h++) {
			for (var c = 0; c < columns; c++) {
				items.eq((h * columns) + c).css('height', heights[h]);
			}
		}
		if (rowCount > 1) {
			items.each(function () {
				$(this).css('margin-bottom', '2rem');
			});
		}

	}

	function getItemHeight(li) {
		li.css('height', 'auto');
		return parseInt(li.css('height'));
	}

}(window.jQuery));